import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import ListaDeProcesos from '../ListaDeProcesos';
import ProcesoDeMatricula from './ProcesoDeMatricula';

type Props = RouteComponentProps<{}>;

const MisMatriculas: React.FunctionComponent<Props> = props => {
    const rutaBase = props.match.url;

    return (
        <div>
            <Route
                exact
                path={rutaBase}
                children={({ match }) => <ListaDeProcesos ocultar={!match} />}
            />
            <Route exact path={rutaBase + '/:id'} component={ProcesoDeMatricula} />
        </div>
    );
};

export default MisMatriculas;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/MisMatriculas/index.tsx